import { Box, CircularProgress } from "@mui/material";

const Preloader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "background.default",
        zIndex: 9999, // Ensures it sits on top of everything including Header
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Rotating Spinner */}
        <CircularProgress
          size={150}
          thickness={1}
          sx={{
            color: "#ff184e",
          }}
        />

        {/* Centered Logo with Pulse Animation */}
        <img
          src="/frontend/assets/logos/logo.png"
          alt="Loading"
          style={{
            position: "absolute",
            width: "100px",
            height: "100px",
            objectFit: "contain",
            animation: "pulse 1.5s infinite ease-in-out",
          }}
        />

        {/* Animation Styles */}
        <style>
          {`
            @keyframes pulse {
              0% { opacity: 0.6; transform: scale(0.85); }
              50% { opacity: 1; transform: scale(1.1); }
              100% { opacity: 0.6; transform: scale(0.85); }
            }
          `}
        </style>
      </Box>
    </Box>
  );
};

export default Preloader;
